
class TawkAPI {

    disabled = false;

    namePrefix = "";

    constructor(){

        this.onLoadQueue = [];

        const context = this;

        window.Tawk_API = {};

        window.Tawk_API.onLoad = function() {

            if(context.disabled){
                window.Tawk_API.hideWidget();
                const widgetElement = document.querySelector("body > div:last-child");
                widgetElement.parentElement.removeChild(widgetElement);

            }

            for(let fn of context.onLoadQueue){

                fn();

            }

        }

    }

    _isLoaded(){
        return Boolean( window.Tawk_API && window.Tawk_API.getStatus)
    }

    _bridge(fnName){
        const {disabled} = this;
        return function() {

            if(disabled && "showWidget" === fnName){
                return;
            }

            if(this._isLoaded()) {

                window.Tawk_API[fnName](...arguments);

            }else{

                this.onLoadQueue.push(()=> window.Tawk_API[fnName](...arguments));

            }

        };

    }

    disable(){
        this.disabled = true;
    }

    enable(){
        this.disabled = false;
    }

    setNamePrefix(prefix){

        this.namePrefix = prefix;

    }

    setAttributes = function(obj){

        let finalObject = obj;

        if(obj.name){

            finalObject = JSON.parse(JSON.stringify(obj));
            finalObject.name = this.namePrefix + finalObject.name;
        }



        return this._setAttributeDirect(finalObject);

    };

    _setAttributeDirect = this._bridge('setAttributes');

    setUser = this._bridge('setAttributes');

    showWidget = this._bridge('showWidget');

    hideWidget = this._bridge('hideWidget');

    endChat = this._bridge('endChat');

    addEvent = this._bridge('addEvent');

    addTags = this._bridge('addTags');

}

export default class TawkPlugin {

    static _generateScript(options){
        let Tawk_LoadStart = new Date();// eslint-disable-line
        let s1 = document.createElement("script");
        let s0 = document.getElementsByTagName("script")[0];
        s1.async = true;
        s1.src = options.tawkSrc;
        s1.charset = 'UTF-8';
        s1.setAttribute('crossorigin', '*');
        s0.parentNode.insertBefore(s1, s0);

    }

    static install(Vue, options) {

        Vue.$Tawk = new TawkAPI();

        Vue.prototype.$Tawk = Vue.$Tawk;

        this._generateScript(options);

    }

}
